<template>
  <div>
    <div>
      <transition name="backdrop-fade">
        <div
          class="backdrop"
          @click="closeSidebarPanel"
          v-show="isPanelOpen"
        ></div>
      </transition>
      <transition name="slide">
        <nav class="side-bar-menu" v-show="isPanelOpen">
          <close-button class="close" @click="closeSidebarPanel"></close-button>
          <ul class="top-menu">
            <li>
              <router-link class="link" to="/">Home</router-link>
            </li>
            <ul v-if="rootStore.loggedIn" class="my-menu">
              <li
                class="pointer"
                @click="viewOrders()"
                v-if="!rootStore.theme.hideOrders"
              >
                Mijn opdrachten
              </li>
              <li
                class="pointer"
                @click.prevent="openUserProfile()"
                v-if="!rootStore.theme.hideProfile"
              >
                Mijn profiel
              </li>
              <li
                class="pointer"
                v-if="fileListStore.fileList.length > 0 && isRijnjaUser"
                @click="shareFiles"
              >
                Bestanden delen
              </li>
            </ul>
            <template v-if="isRijnja">
              <li>
                <router-link class="link" to="/wat-wij-doen"
                  >Wat wij doen</router-link
                >
                <ul>
                  <li>
                    <router-link class="link" to="/print-uitbesteden"
                      >Print uitbesteden</router-link
                    >
                  </li>
                  <li>
                    <router-link class="link" to="/print-aanbesteden"
                      >Print aanbesteden</router-link
                    >
                  </li>
                  <li>
                    <router-link class="link" to="/secured-printing"
                      >Secured printing</router-link
                    >
                  </li>
                  <li>
                    <router-link class="link" to="/digitaliseren"
                      >Digitaliseren</router-link
                    >
                  </li>
                  <li>
                    <router-link class="link" to="/printstore"
                      >Signing</router-link
                    >
                  </li>
                </ul>
              </li>
              <li>
                <router-link class="link" to="/hoe-doen-wij-dat"
                  >Hoe doen wij dat
                </router-link>
                <ul>
                  <li>
                    <router-link class="link" to="/duurzaam"
                      >Duurzaam
                    </router-link>
                  </li>
                </ul>
              </li>
              <li>
                <router-link class="link" to="/home#voor-wie"
                  >Voor wie doen wij dat
                </router-link>
              </li>
              <li>
                <router-link class="link" to="/over-rijnja"
                  >Over ons
                </router-link>
              </li>
              <!--               <li>
                <router-link class="link" to="/werken-bij-rijnja"
                  >Werken bij Rijnja</router-link
                >
              </li> -->
              <li>
                <router-link class="link" to="/contact">Contact</router-link>
              </li>
            </template>
            <template v-else>
              <!--  <li>
                <router-link class="link" to="/faq">FAQ</router-link>
              </li> -->
              <li>
                <router-link class="link" to="/contact">Contact</router-link>
              </li>
            </template>
          </ul>
          <ul v-if="!rootStore.loggedIn" class="login-menu">
            <li v-if="!rootStore.loggedIn">
              <button @click="openDialog('login')" class="pill-button">
                Inloggen
              </button>
            </li>

            <li class="modal">
              <button @click="signUp" class="pill-button secondary">
                Maak een account aan
              </button>
            </li>
          </ul>
          <ul class="login-menu" v-else>
            <li v-if="!rootStore.theme.hideLogOut && rootStore.loggedIn">
              <button @click="logout()" class="pill-button">
                Uitloggen
              </button>
            </li>
          </ul>
        </nav>
      </transition>
    </div>
  </div>
</template>

<script>
import { useFileListStore } from '@/stores/FileList.store'
import FileTransferModal from '@/dialogs/FileTransfer.vue'
import LogoutMixin from '@/mixins/LogoutMixin'
import OrderHistoryDialog from '@/features/orderHistory/OrderHistoryDialog.vue'
import SignUp2 from '@/dialogs/SignUp2.vue'
import { mapStores } from 'pinia'
import UserSettings from '@/dialogs/UserSettings.vue'

export default {
  mixins: [LogoutMixin],
  methods: {
    viewOrders() {
      this.rootStore.toggleSideBar(false)
      this.$modal.show(
        OrderHistoryDialog,
        {},
        {
          width: 650,
          maxWidth: 650,
          adaptive: true,
          height: window.innerHeight * 0.6
        }
      )
    },
    closeSidebarPanel() {
      this.rootStore.toggleSideBar(false)
    },
    openDialog(val) {
      this.rootStore.toggleSideBar(false)
      this.$modal.show(val)
    },
    openUserProfile() {
      this.rootStore.toggleSideBar(false)
      this.$modal.show(
        UserSettings,
        {
          user: this.rootStore.user
        },
        {
          height: 'auto',
          width: 420,
          scrollable: true
        }
      )
    },
    signUp() {
      this.rootStore.toggleSideBar(false)
      this.$modal.show(SignUp2, null, {
        height: 'auto',
        width: 420,
        scrollable: true
      })
    },
    shareFiles() {
      this.rootStore.toggleSideBar(false)
      this.$modal.show(
        FileTransferModal,
        { shareUploads: true },
        {
          width: 500,
          height: 'auto',
          adaptive: true
        }
      )
    }
  },
  computed: {
    ...mapStores(useFileListStore),
    isPanelOpen() {
      return this.rootStore.isNavOpen
    },
    isRijnja() {
      return this.rootStore.theme.showRijnjaContent
    },
    isRijnjaUser() {
      if (
        /@rijnja.nl\s*$/.test(this.rootStore.user.username) ||
        /@boplicity.nl\s*$/.test(this.rootStore.user.username) ||
        /@raadkracht.nl\s*$/.test(this.rootStore.user.username)
      ) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    $route() {
      this.rootStore.toggleSideBar(false)
    }
  }
}
</script>

<style lang="scss" scoped>
@use '../sass/base/_colors.scss' as *;

.side-bar-menu {
  background: white;
  box-shadow: rgba(0, 0, 0, 0.2) 20px 0px 50px;
  left: 15px;
  padding: 20px;
  position: fixed;
  top: 15px;
  bottom: 15px;
  max-width: 350px;
  width: calc(100vw - 30px);
  z-index: 115;
  border-radius: 25px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  //  font-size: 14px;
}

.top-menu {
  flex-grow: 1;
  overflow-y: auto;
  margin-right: -10px;
  padding-right: 10px;
  padding-top: 8px;
}

.close {
  position: absolute;
  right: 20px;
  top: 20px;
  z-index: 10;
}

li {
  padding: 0 20px;
  color: $text-color;
  display: block;
  margin-right: 20px;
  text-decoration: none;
  line-height: 45px;
  font-weight: 500;

  a {
    text-decoration: none;
    display: block;

    &:hover {
      color: #012169;
    }

    &.router-link-exact-active {
      color: #012169;
      font-weight: 600;
    }
  }
}

.login-menu {
  li {
    width: 100%;
    padding: 0 10px 0;
    cursor: pointer;

    button {
      width: 100%;
    }
  }
}

.my-menu {
  border-top: 1px solid $divider;
  border-bottom: 1px solid $divider;

  li:hover {
    color: #012169;
  }
}

.slide-enter-from,
.slide-leave-to {
  transform: translateX(-110%);
}

.slide-enter-to,
.slide-leave-from {
  transform: translateX(0);
}

.slide-enter-active,
.slide-leave-active {
  transition: transform 0.3s ease;
}

@media only screen and (min-width: 480px) {
  .side-bar-menu {
    left: 32px;
    top: 32px;
    bottom: 27px;
  }
}
</style>
